import FormattedText, { TextNodeType } from "../FormattedText/FormattedText";
import MarkdownText from "../MarkdownText/MarkdownText";

export interface RichTextProps {
  value?: string | TextNodeType;
}

const RichText = ({ value }: RichTextProps) => {
  if (typeof value === "string") {
    return <MarkdownText value={value} />;
  }
  return <FormattedText value={value} />;
};

export default RichText;
